export const images = {
   logo: require('../images/logo.png'),
   icon_mobile_bar_1 : require('../images/icon_mobile_bar_1.png'),
   icon_mobile_bar_2 : require('../images/icon_mobile_bar_2.png'),
   icon_mobile_bar_3 : require('../images/icon_mobile_bar_3.png'),
   icon_mobile_bar_4 : require('../images/icon_mobile_bar_4.png'),
   // ===== 메인 페이지 =====
   R_step_item_01: require('../images/R_step_item_01.png'),
   R_step_item_02: require('../images/R_step_item_02.png'),
   R_step_item_03: require('../images/R_step_item_03.png'),
   R_step_item_04: require('../images/R_step_item_04.png'),
   R_step_item_05: require('../images/R_step_item_05.png'),
   R_step_item_06: require('../images/R_step_item_06.png'),
   R_popup_01: require('../images/R_popup_01.png'),
   R_popup_02: require('../images/R_popup_02.png'),
   R_popup_03: require('../images/R_popup_03.png'),
   R_popup_04: require('../images/R_popup_04.png'),
   R_popup_05: require('../images/R_popup_05.png'),
   R_popup_06: require('../images/R_popup_06.png'),
   life_score_btn: require('../images/life_score_btn.png'),
   icon_checkbox: require('../images/icon_checkbox.png'),
   metaQ: require('../images/metaQ.png'),
   academia_item_01: require('../images/academia_item_01.webp'),
   academia_item_02: require('../images/academia_item_02.webp'),
   academia_item_03: require('../images/academia_item_03.webp'),
   academia_item_04: require('../images/academia_item_04.webp'),
   // company
   about_section_01: require('../images/about_section_01.png'),
   about_section_01_m: require('../images/about_section_01_m.png'),
   icon_about_section_01: require('../images/icon_about_section_01.png'),
   icon_about_section_02: require('../images/icon_about_section_02.png'),
   icon_about_section_03: require('../images/icon_about_section_03.png'),
   icon_about_section_04: require('../images/icon_about_section_04.png'),
   sapienza_item_01: require('../images/sapienza_item_01.png'),
   sapienza_item_02: require('../images/sapienza_item_02.png'),
   sapienza_item_03: require('../images/sapienza_item_03.png'),
   sapienza_item_04: require('../images/sapienza_item_04.png'),
   sapienza_item_05: require('../images/sapienza_item_05.png'),
   sapienza_item_06: require('../images/sapienza_item_06.png'),
   mind_theraphy_item_01: require('../images/mind_theraphy_item_01.png'),
   mind_theraphy_item_02: require('../images/mind_theraphy_item_02.png'),
   mind_theraphy_item_03: require('../images/mind_theraphy_item_03.png'),
   mind_theraphy_item_04: require('../images/mind_theraphy_item_04.png'),
   mind_theraphy_item_05: require('../images/mind_theraphy_item_05.png'),
   mind_theraphy_item_06: require('../images/mind_theraphy_item_06.png'),
   // ===== 마인드 인사이트 =====
   mind_insight_about: require('../images/mind_insight_about.png'),
   mind_sight_about_section_01: require('../images/mind_sight_about_section_01.png'),
   mind_sight_about_section_01_m: require('../images/mind_sight_about_section_01_m.png'),
   mind_sight_about_section_02_arrow: require('../images/mind_sight_about_section_02_arrow.png'),
   mind_sight_about_section_03_01: require('../images/mind_sight_about_section_03_01.png'),
   mind_sight_about_section_03_02: require('../images/mind_sight_about_section_03_02.png'),
   mind_sight_about_section_03_03: require('../images/mind_sight_about_section_03_03.png'),
   mind_sight_about_section_03_04: require('../images/mind_sight_about_section_03_04.png'),
   test_btn: require('../images/test_btn.png'),
   mind_sight_about_section_04: require('../images/mind_sight_about_section_04.png'),
   mind_sight_about_section_04_mb: require('../images/mind_sight_about_section_04_mb.png'),
   metaQ_green: require('../images/metaQ_green.png'),
   icon_check_green: require('../images/icon_check_green.png'),
   mind_insight_thumbnail_01: require('../images/mind_insight_thumbnail_01.png'),
   mind_insight_02_02_01: require('../images/mind_insight_02_02_01.png'),
   mind_insight_detail_01_01: require('../images/mind_insight_detail_01_01.png'),
   mind_insight_detail_01_01_m: require('../images/mind_insight_detail_01_01_m.png'),
   mind_insight_detail_01_02: require('../images/mind_insight_detail_01_02.png'),
   mind_insight_detail_01_02_m: require('../images/mind_insight_detail_01_02_m.png'),
   mind_insight_02_03_01: require('../images/mind_insight_02_03_01.png'),
   mind_insight_02_03_02: require('../images/mind_insight_02_03_02.png'),
   mind_insight_02_03_03: require('../images/mind_insight_02_03_03.png'),
   mind_insight_02_03_04: require('../images/mind_insight_02_03_04.png'),
   mind_insight_02_04_01: require('../images/mind_insight_02_04_01.png'),
   mind_insight_02_04_02: require('../images/mind_insight_02_04_02.png'),
   mind_insight_02_04_03: require('../images/mind_insight_02_04_03.png'),
   mind_insight_02_04_04: require('../images/mind_insight_02_04_04.png'),
   mind_insight_02_05_01: require('../images/mind_insight_02_05_01.png'),
   mind_insight_detail_04_01: require('../images/mind_insight_detail_04_01.png'),
   mind_insight_detail_04_01_m: require('../images/mind_insight_detail_04_01_m.png'),
   mind_insight_detail_04_02_01: require('../images/mind_insight_detail_04_02_01.jpg'),
   mind_insight_detail_04_02_02: require('../images/mind_insight_detail_04_02_02.jpg'),
   mind_insight_detail_04_02_03: require('../images/mind_insight_detail_04_02_03.jpg'),
   mind_insight_detail_04_02_04: require('../images/mind_insight_detail_04_02_04.jpg'),
   mind_insight_detail_04_02_05: require('../images/mind_insight_detail_04_02_05.jpg'),
   mind_insight_detail_04_02_06: require('../images/mind_insight_detail_04_02_06.jpg'),
   mind_insight_02_06_01: require('../images/mind_insight_02_06_01.png'),
   mind_insight_detail_04_02_01_png: require('../images/mind_insight_detail_04_02_01.png'),
   mind_insight_detail_04_02_02_png: require('../images/mind_insight_detail_04_02_02.png'),
   mind_insight_thumbnail_02: require('../images/mind_insight_thumbnail_02.png'),
   mind_report_sub_top: require('../images/mind_report_sub_top.png'),
   mind_report_02_01: require('../images/mind_report_02_01.png'),
   mind_report_03_01: require('../images/mind_report_03_01.png'),
   mind_report_03_02: require('../images/mind_report_03_02.png'),
   mind_report_03_03: require('../images/mind_report_03_03.png'),
   mind_report_03_04: require('../images/mind_report_03_04.png'),
   mind_insight_thumbnail_03: require('../images/mind_insight_thumbnail_03.png'),
   mind_insight_counseling_sub_top: require('../images/mind_insight_counseling_sub_top.png'),
   mind_insight_counseling_01: require('../images/mind_insight_counseling_01.png'),
   mind_insight_counseling_01_m: require('../images/mind_insight_counseling_01_m.png'),
   mind_therapy_thumbnail_01: require('../images/mind_therapy_thumbnail_01.png'),
   mind_therapy_sub_top_01: require('../images/mind_therapy_sub_top_01.png'),
   mind_therapy_01_02: require('../images/mind_therapy_01_02.png'),
   mind_therapy_01_03_01: require('../images/mind_therapy_01_03_01.png'),
   mind_therapy_01_04_01: require('../images/mind_therapy_01_04_01.png'),
   mind_therapy_01_04_02: require('../images/mind_therapy_01_04_02.png'),
   mind_therapy_01_04_03: require('../images/mind_therapy_01_04_03.png'),
   mind_therapy_thumbnail_02: require('../images/mind_therapy_thumbnail_02.png'),
   mind_therapy_02_01: require('../images/mind_therapy_02_01.png'),
   mind_therapy_02_03_01: require('../images/mind_therapy_02_03_01.png'),
   mind_therapy_02_03_02: require('../images/mind_therapy_02_03_02.png'),
   mind_therapy_02_04_01: require('../images/mind_therapy_02_04_01.png'),
   mind_therapy_02_04_02: require('../images/mind_therapy_02_04_02.png'),
   mind_therapy_thumbnail_03: require('../images/mind_therapy_thumbnail_03.png'),
   mind_therapy_03_01: require('../images/mind_therapy_03_01.png'),
   mind_therapy_03_02_01: require('../images/mind_therapy_03_02_01.png'),
   mind_therapy_03_02_02: require('../images/mind_therapy_03_02_02.png'),
   mind_therapy_03_02_03: require('../images/mind_therapy_03_02_03.png'),
   mind_therapy_03_02_04: require('../images/mind_therapy_03_02_04.png'),
   mind_therapy_03_02_05: require('../images/mind_therapy_03_02_05.png'),
   mind_therapy_03_03_01: require('../images/mind_therapy_03_03_01.png'),
   mind_therapy_03_04_01: require('../images/mind_therapy_03_04_01.png'),
   mind_therapy_03_04_02: require('../images/mind_therapy_03_04_02.png'),
   mind_therapy_03_04_03: require('../images/mind_therapy_03_04_03.png'),
   mind_therapy_03_04_04: require('../images/mind_therapy_03_04_04.png'),
   mind_therapy_03_04_05: require('../images/mind_therapy_03_04_05.png'),
   mind_therapy_03_04_06: require('../images/mind_therapy_03_04_06.png'),
   mind_therapy_03_04_07: require('../images/mind_therapy_03_04_07.png'),
   mind_therapy_03_04_08: require('../images/mind_therapy_03_04_08.png'),
   mind_therapy_thumbnail_04: require('../images/mind_therapy_thumbnail_04.png'),
   mind_therapy_04_01: require('../images/mind_therapy_04_01.png'),
   mind_therapy_04_02: require('../images/mind_therapy_04_02.png'),
   mind_therapy_04_03_01: require('../images/mind_therapy_04_03_01.png'),
   mind_therapy_04_03_02: require('../images/mind_therapy_04_03_02.png'),
   mind_therapy_04_03_03: require('../images/mind_therapy_04_03_03.png'),
   mind_therapy_04_03_04: require('../images/mind_therapy_04_03_04.png'),
   mind_therapy_04_03_05: require('../images/mind_therapy_04_03_05.png'),
   mind_therapy_04_03_06: require('../images/mind_therapy_04_03_06.png'),
   mind_therapy_thumbnail_05: require('../images/mind_therapy_thumbnail_05.png'),
   mind_therapy_05_01: require('../images/mind_therapy_05_01.png'),
   mind_therapy_05_02: require('../images/mind_therapy_05_02.png'),
   mind_therapy_05_04_01: require('../images/mind_therapy_05_04_01.png'),
   mind_therapy_05_04_02: require('../images/mind_therapy_05_04_02.png'),
   mind_therapy_05_04_03: require('../images/mind_therapy_05_04_03.png'),
   sub04_sapienza_main: require('../images/sub04_sapienza_main.png'),
   sub04_sapienza_02: require('../images/sub04_sapienza_02.png'),
   icon_comma_brown: require('../images/icon_comma_brown.png'),
   sub04_sapienza_04: require('../images/sub04_sapienza_04.png'),
   sub04_sapienza_04_m: require('../images/sub04_sapienza_04_m.png'),
   icon_comma_white_opacity: require('../images/icon_comma_white_opacity.png'),
   sub04_sapienza_03_01: require('../images/sub04_sapienza_03_01.png'),
   sub04_sapienza_03_02: require('../images/sub04_sapienza_03_02.png'),
   sub04_sapienza_03_03: require('../images/sub04_sapienza_03_03.png'),
   sub04_sapienza_03_04: require('../images/sub04_sapienza_03_04.png'),
   sub04_sapienza_sub_top: require('../images/sub04_sapienza_sub_top.png'),
   sub04_sapienza_02_01: require('../images/sub04_sapienza_02_01.png'),
   sub04_sapienza_02_02: require('../images/sub04_sapienza_02_02.png'),
   sub04_sapienza_02_03: require('../images/sub04_sapienza_02_03.png'),
   sub04_sapienza_02_04: require('../images/sub04_sapienza_02_04.png'),
   footer_logo: require('../images/footer_logo.png'),
   sns_btn_kc: require('../images/sns_btn_kc.png'),
   sns_btn_insta: require('../images/sns_btn_insta.png'),
   sns_btn_blog: require('../images/sns_btn_blog.png'),
   sns_btn_ytb: require('../images/sns_btn_ytb.png'),
   sns_btn_ks: require('../images/sns_btn_ks.png'),
   sns_btn_band: require('../images/sns_btn_band.png'),
   sns_btn_fb: require('../images/sns_btn_fb.png'),
   sub05_sub_top: require('../images/sub05_sub_top.png'),
   sub05_counselor_01: require('../images/sub05_counselor_01.png'),
   sub05_counselor_01_m: require('../images/sub05_counselor_01_m.png'),
   sub05_center_01: require('../images/sub05_center_01.png'),
   sub05_center_01_m: require('../images/sub05_center_01_m.png'),
   counseling_system_item_02: require('../images/counseling_system_item_02.png'),
   counseling_system_item_03: require('../images/counseling_system_item_03.png'),
   counseling_system_item_04: require('../images/counseling_system_item_04.png'),
   counseling_system_item_05: require('../images/counseling_system_item_05.png'),
   login_select_01: require('../images/login_select_01.png'),
   login_select_02: require('../images/login_select_02.png'),
   never_login: require('../images/never-login.png'),
   kakao_login: require('../images/kakao-login.png'),
   apple_login: require('../images/apple-login.png'),
   icon_pen: require('../images/icon_pen.png'),
   icon_message: require('../images/icon_message.png'),
   test_guide_step_01: require('../images/test_guide_step_01.png'),
   test_guide_step_02: require('../images/test_guide_step_02.png'),
   test_guide_step_03: require('../images/test_guide_step_03.png'),
   test_guide_step_04: require('../images/test_guide_step_04.png'),
   test_guide_step_05: require('../images/test_guide_step_05.png'),
   icon_naver_pay: require('../images/icon_naver_pay.png'),
   icon_kakao_pay: require('../images/icon_kakao_pay.png'),
   // ===== 마인드 인사이트 검사 =====
   intro_top: require('../images/mind-insight-test/intro_top.png'),
   side_img: require('../images/mind-insight-test/side_img.png'),
   // ===== 인생점수 =====
   life_score_intro: require('../images/life-score/intro.png'),
   life_score_sub_banner: require('../images/life-score/sub_banner.png'),
};